import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-2755c3f6"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  class: "snackbar-container tw-fixed tw-bottom-10px tw-left-10px tw-z-[2000] max-sm:tw-w-full max-sm:tw-left-0"
};
var _hoisted_2 = ["data-cy"];
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = {
  key: 1,
  class: "snackbar-type-icon tw-bg-contain tw-bg-no-repeat"
};
var _hoisted_5 = {
  class: "snackbar-text tw-text sm:tw-text-16 tw-py-0 tw-px-4 tw-font-regular max-sm:tw-max-w-[80%] max-sm:tw-pr-0"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
import { CloseIcon } from "@vueEntry/SvgIcons/CloseIcon";
import { computed, onBeforeMount, ref } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseSnackbar',
  props: {
    type: {
      default: ""
    },
    title: {},
    body: {},
    icon: {},
    timeout: {
      default: 55000
    },
    cb: {
      default: null
    }
  },
  emits: ["snackbar-hidden"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    //@ts-ignore
    var props = __props;
    var emits = __emit;
    var onSnackbarClick = ref(null);
    var snackbar = ref(null);
    var cdn = computed(() => window["_cdn"]);
    var handleSnackbarClick = () => {
      onSnackbarClick.value && onSnackbarClick.value();
    };
    var handleSnackbarClose = () => {
      var snackbarEl = snackbar.value;
      /* The snackbar could be null when we manually close it and the callback tries to perform the same action.
      * In that scenario the ordering and state are the following:
      * 0) On created a timer is initialized which will retrieve the snackbar element and add the snackbar-hidden class
      * 1) User clicks on 'X' button to close the snackbar
      * 2) handleSnackbarClose function is called before the callback function triggers
      *   2.1) the handleSnackbarClose function emits the event snackbar-hidden which will destroy the BaseSnackbar component (and all its content)
      * 3) The BaseSnackbar does not exist anymore
      * 4) The callback is triggered but the snackbar element is not present in our DOM, so, an exception will be thrown if the snackbar element is null
      * */
      if (!snackbarEl) return;
      snackbarEl.classList.remove("snackbar-active");
      snackbarEl.classList.add("snackbar-hidden");
      setTimeout(() => {
        emits("snackbar-hidden");
      }, 300);
    };
    onBeforeMount(() => {
      /* If present, we will sync the cb with the handler */
      if (props.cb) onSnackbarClick.value = props.cb;
      setTimeout(() => {
        /* auto closing */
        handleSnackbarClose();
      }, props.timeout);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "snackbar",
        ref: snackbar,
        "data-cy": _ctx.$attrs['data-cy'],
        class: _normalizeClass(["snackbar snackbar-active tw-flex tw-items-center tw-rounded-[5px] tw-py-10px tw-px-4 tw-font-medium tw-shadow hover:tw-cursor-pointer max-sm:tw-relative max-sm:tw-mx-10px max-sm:tw-my-0", _ctx.type]),
        onClick: _withModifiers(handleSnackbarClick, ["stop"])
      }, [_ctx.icon ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: "".concat(cdn.value, "/").concat(_ctx.icon.src),
        alt: "".concat(_ctx.icon.alt),
        width: "20",
        height: "20"
      }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true), _ctx.type && !_ctx.icon ? (_openBlock(), _createElementBlock("span", _hoisted_4)) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_5, [_ctx.title ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "tw-m-0",
        innerHTML: _ctx.title
      }, null, 8 /* PROPS */, _hoisted_6)) : _createCommentVNode("v-if", true), _ctx.body ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        class: "tw-m-0",
        innerHTML: _ctx.body
      }, null, 8 /* PROPS */, _hoisted_7)) : _createCommentVNode("v-if", true)]), _createElementVNode("button", {
        type: "button",
        "data-cy": "base-snackbar-close-btn",
        class: "max-sm:tw-absolute max-sm:tw-right-5 tw-bg-transparent",
        onClick: _withModifiers(handleSnackbarClose, ["stop"])
      }, [_createVNode(_unref(CloseIcon), {
        class: "snackbar-close-icon",
        width: 20,
        height: 20,
        "stroke-color": "#000"
      })])], 10 /* CLASS, PROPS */, _hoisted_2)]);
    };
  }
}));